import { atom } from "recoil";

// 로컬스토리지에서 가이드 설정 불러오기
const getGuideFromStorage = () => {
  // 항상 false로 시작 (이용 가이드는 기본적으로 off)
  return false;
};

export const settingState = atom({
  key: "settingState", // 고유한 key 값 설정
  default: {
    guide: getGuideFromStorage(),
  },
});
